import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Comparison() {
  return <section className="py-12 px-4" data-id="element-26">
      <div className="max-w-lg mx-auto" data-id="element-27">
        <h2 className="text-2xl font-bold text-center text-white mb-8 drop-shadow-lg" data-id="element-28">
          La diferencia es clara
        </h2>

        <div className="flex rounded-xl overflow-hidden shadow-lg border border-white/40 text-sm md:text-base" data-id="element-29">
          {/* Sin Kit */}
          <div className="w-1/2 bg-red-50 p-4 border-r border-slate-200" data-id="element-30">
            <div className="text-center mb-4 pb-4 border-b border-red-200" data-id="element-31">
              <h3 className="font-bold text-red-800 leading-tight" data-id="element-32">
                Sin Kit RRHH Hospital
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-33">
              <li className="flex items-start gap-2" data-id="element-34">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-35" />
                <span className="text-slate-700 text-xs md:text-sm" data-id="element-36">
                  Planillas desactualizadas y caóticas
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-37">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-38" />
                <span className="text-slate-700 text-xs md:text-sm" data-id="element-39">
                  Riesgo de multas por matrículas vencidas
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-40">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-41" />
                <span className="text-slate-700 text-xs md:text-sm" data-id="element-42">
                  Horas perdidas armando guardias
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-43">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-44" />
                <span className="text-slate-700 text-xs md:text-sm" data-id="element-45">
                  Pánico ante auditorías del Ministerio
                </span>
              </li>
            </ul>
          </div>

          {/* Con Kit */}
          <div className="w-1/2 bg-teal-50 p-4" data-id="element-46">
            <div className="text-center mb-4 pb-4 border-b border-teal-200" data-id="element-47">
              <h3 className="font-bold text-teal-800 leading-tight" data-id="element-48">
                Con Kit RRHH Hospital
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-49">
              <li className="flex items-start gap-2" data-id="element-50">
                <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-51" />
                <span className="text-slate-800 font-medium text-xs md:text-sm" data-id="element-52">
                  Todo organizado en un solo lugar
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-53">
                <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-54" />
                <span className="text-slate-800 font-medium text-xs md:text-sm" data-id="element-55">
                  Semáforo automático de vencimientos
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-56">
                <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-57" />
                <span className="text-slate-800 font-medium text-xs md:text-sm" data-id="element-58">
                  Planificador de turnos 24/7 sin errores
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-59">
                <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-60" />
                <span className="text-slate-800 font-medium text-xs md:text-sm" data-id="element-61">
                  Tranquilidad total ante inspecciones
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}